<div class="view-container">
    <app-header></app-header>
</div>
